import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { setIsWebinarLive } from '../../../firebase/hooks/useWebinarGlobalState'

const getIsWebinarBroadcasting = (state: any): boolean =>
  Boolean(state.webinar?.webinarInfo?.broadcasting_p) || false

/**
 * This component make sure to sync the live status of a webinar both when going
 * live and each time the producer reloads the webinar room. This is in the case
 * of a producer not having access to firebase, perhaps because of the producers
 * current network configuration, so they can change the network, reload and the
 * status is automatically synced.
 */
const WebinarLiveSync = () => {
  const isAttemptedOnce = useRef(false)
  const isWebinarBroadcasting = useSelector(getIsWebinarBroadcasting)

  useEffect(() => {
    if (!isAttemptedOnce.current && isWebinarBroadcasting) {
      setIsWebinarLive(true)
      isAttemptedOnce.current = true
    }
  }, [isWebinarBroadcasting])

  return null
}

export default WebinarLiveSync
